import type { FC, ButtonHTMLAttributes } from 'react';
import styles from '../styles/action-button.module.scss';

const ActionButton: FC<
    {
        primary?: boolean;
        title: string;
        loading?: boolean;
    } & ButtonHTMLAttributes<HTMLButtonElement>
> = ({ primary = true, className = '', title, loading = false, disabled, ...props }) => {
    return (
        <button
            className={`${styles.button} ${primary ? styles.primary : styles.secondary} ${className}`}
            disabled={disabled || loading}
            aria-busy={loading}
            {...props}
        >
            <span className={styles.content}>
                {loading && <span className={styles.spinner} aria-hidden="true" />}
                <span>{title}</span>
            </span>
        </button>
    );
};

export default ActionButton;
